import { useContext, useEffect, useState } from 'react';
import { CashIcon, ChatAlt2Icon, ChatIcon, MenuIcon, SearchIcon, ServerIcon, UserIcon } from "@heroicons/react/solid";
import { useIntercom } from 'react-use-intercom'

import Link from '@/components/Link'
import { LayoutContext } from '@/contexts/LayoutContext';
import modalRoutes from '../modalRoutes';

export default function BottomNavigation() {
  const [body, setBody] = useState(null)
  const { toggleSidebar, toggleChat } = useContext(LayoutContext)
  const { showNewMessages } = useIntercom()

  useEffect(() => {
    if (body) return null
    setBody(document?.querySelector('body'))
  }, [])

  const lock = () => body.classList.add('overflow-hidden')

  return (
    <div className="md:hidden fixed inset-x-0 bottom-0 bg-gray-900 rounded-t-md grid grid-cols-5 z-10 border-t border-gray-800">
      <button onClick={toggleSidebar} className="flex flex-col items-center justify-center py-2.5">
        <MenuIcon className="h-4 w-4 text-gray-300 mb-1" />
        <span className="text-xs font-medium">Menu</span>
      </button>
      <Link className="flex flex-col items-center justify-center py-2.5" to={modalRoutes.DEPOSIT}>
        <CashIcon className="h-4 w-4 text-gray-300 mb-1" />
        <span className="text-xs font-medium">Cashier</span>
      </Link>
      <Link className="flex flex-col items-center justify-center py-2.5" to="/arena">
        <ServerIcon className="h-4 w-4 text-gray-300 mb-1" />
        <span className="text-xs font-medium">Stake</span>
      </Link>
      <button onClick={toggleChat} className="flex flex-col items-center justify-center py-2.5">
        <ChatIcon className="h-4 w-4 text-gray-300 mb-1" />
        <span className="text-xs font-medium">Chat</span>
      </button>
      <button className="flex flex-col items-center justify-center py-2.5" onClick={() => showNewMessages('')}>
        <ChatAlt2Icon className="h-4 w-4 text-gray-300 mb-1" />
        <span className="text-xs font-medium">Support</span>
      </button>
    </div>
  )
}